import { atom } from "jotai";
import { ActivationSteps } from "@payping/api/app/api/bnplMerchantTypes";

interface InstallmentPaymentAtom {
  bnplActivationStep?: ActivationSteps;
}
export const installmentPaymentAtom = atom<InstallmentPaymentAtom>({
  bnplActivationStep: undefined,
});
